module.exports = __webpack_public_path__ + "static/img/yunplat.61a681c6.jpg";